<template>
  <v-dialog
    v-if="activeAnnouncement"
    v-model="dialog"
    content-class="popup-announcement-dialog"
    max-width="620"
    persistent
  >
    <component :is="activeComponent" @dismiss="dismiss" />
  </v-dialog>
</template>

<style lang="scss">
.popup-announcement-dialog {
  border-radius: 18px;
}
</style>

<script>
import { mapGetters } from "vuex";
import { hasPermissions } from "@/view/mixins";
import PaymentAnnouncement06052026 from "./PaymentAnnouncement06-05-2026.vue";

const ANNOUNCEMENTS = [
  {
    id: "payment-announcement-06-05-2026",
    component: PaymentAnnouncement06052026,
    enabled: () => process.env.VUE_APP_PAYMENT_ANNOUNCEMENT_ENABLED === "true",
    roles: ["companyadmin", "local_cluster_manager", "superadministrator"],
  },
];

export default {
  name: "PopupAnnouncement",
  mixins: [hasPermissions],
  data() {
    return {
      activeAnnouncement: null,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"]),

    activeComponent() {
      return this.activeAnnouncement ? this.activeAnnouncement.component : null;
    },
  },
  mounted() {
    this.maybeShow();
  },
  watch: {
    currentUser: {
      deep: true,
      handler() {
        this.maybeShow();
      },
    },
  },
  methods: {
    maybeShow() {
      if (
        this.dialog ||
        !this.isAuthenticated ||
        !this.currentUser ||
        !this.currentUser.id ||
        this.currentUser.consented_on === null
      ) {
        return;
      }

      const announcement = ANNOUNCEMENTS.find((item) =>
        this.canShowAnnouncement(item)
      );

      if (!announcement) {
        return;
      }

      this.activeAnnouncement = announcement;
      this.dialog = true;
    },
    canShowAnnouncement(announcement) {
      if (!announcement.enabled()) {
        return false;
      }

      if (
        announcement.roles.length &&
        !announcement.roles.some((role) => this.hasRole(role))
      ) {
        return false;
      }

      try {
        return !window.localStorage.getItem(this.getStorageKey(announcement));
      } catch {
        return true;
      }
    },
    dismiss() {
      if (this.activeAnnouncement) {
        try {
          window.localStorage.setItem(
            this.getStorageKey(this.activeAnnouncement),
            new Date().toISOString()
          );
        } catch {
          // Ignore storage failures; closing the dialog should still work.
        }
      }

      this.dialog = false;
      this.activeAnnouncement = null;
    },
    getStorageKey(announcement) {
      return `robosay:popup:announcements:${announcement.id}:user:${this.currentUser.id}`;
    },
  },
};
</script>
